import {
  ChangeDetectionStrategy,
  Component,
  ContentChild,
  EventEmitter,
  Input,
  Output,
  TemplateRef,
  inject,
} from '@angular/core';
import { FaceFilterType } from '@freelancer/components/face-filter';
import { ButtonColor, ButtonSize } from '@freelancer/ui/button';
import { IconSize } from '@freelancer/ui/icon';
import { ModalColor, ModalService, ModalSize } from '@freelancer/ui/modal';

@Component({
  standalone: false,
  selector: 'fl-video-record-input',
  template: `
    <fl-button
      i18n="Record video button"
      [color]="color"
      [size]="size"
      (click)="openModal()"
    >
      @if (showIcon) {
        <fl-icon
          class="mr-xxxsmall"
          [name]="'ui-camera'"
          [size]="IconSize.MID"
          [useIconFont]="true"
          [fillIconFont]="true"
        ></fl-icon>
      }
      {{ ctaText }}
    </fl-button>
  `,
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class VideoRecordInputComponent {
  private modalService = inject(ModalService);

  IconSize = IconSize;

  @Input() modalHeader?: string;
  @Input() modalTitle?: string;
  /** When true, shows the video camera icon on the button. */
  @Input() showIcon = false;
  @Input() color = ButtonColor.DEFAULT;
  @Input() size = ButtonSize.SMALL;
  @Input() ctaText = $localize`Record video`;
  @Input() faceFilterType: FaceFilterType = 'none';
  @Input() showCloseButton = true;
  @Input() modalColor = ModalColor.LIGHT;

  @ContentChild('contentWhileRecording')
  contentWhileRecording?: TemplateRef<any>;

  @Output() clicked = new EventEmitter<void>();
  @Output() videoRecorded = new EventEmitter<File | undefined>();

  @ContentChild('content') content?: TemplateRef<any>;
  @ContentChild('subContent')
  subContent?: TemplateRef<any>;

  async openModal(): Promise<void> {
    this.clicked.emit();
    const videoRecord = await this.modalService
      .open('VideoRecordModal', {
        size: ModalSize.MID,
        edgeToEdge: true,
        closeable: false,
        mobileFullscreen: true,
        color: this.modalColor,
        inputs: {
          content: this.content,
          faceFilterType: this.faceFilterType,
          subContent: this.subContent,
          modalHeader: this.modalHeader,
          modalTitle: this.modalTitle,
          contentWhileRecording: this.contentWhileRecording,
          showCloseButton: this.showCloseButton,
          mobileFullscreen: true,
        },
      })
      .afterClosed();

    this.videoRecorded.emit(videoRecord);
  }
}
